import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'
import { callApi } from 'duck/operations'
import { all, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { ActionType, getType } from 'typesafe-actions'

import {
  createInvestorCheckBegin,
  createInvestorCheckFailure,
  createInvestorCheckSuccess,
  deleteInvestorCheckBegin,
  deleteInvestorCheckFailure,
  deleteInvestorCheckSuccess,
  fetchAvailableChecksBegin,
  fetchAvailableChecksSuccess,
  fetchInvestorChecksBegin,
  fetchInvestorChecksSuccess,
  updateInvestorCheckBegin,
  updateInvestorCheckFailure,
  updateInvestorCheckSuccess,
} from './actions'
import {
  apiCreateInvestorCheck,
  apiDeleteInvestorCheck,
  apiGetAvailableChecks,
  apiGetInvestorChecks,
  apiUpdateInvestorCheck,
} from './api'
import { ChecksConfig, IdIndexedInvestorChecks, InvestorCheck } from './types'

export function* investorChecksSaga() {
  yield all([
    takeLatest(getType(fetchAvailableChecksBegin), fetchAvailableChecks),
    takeLatest(getType(fetchInvestorChecksBegin), fetchInvestorChecks),
    takeEvery(getType(deleteInvestorCheckBegin), sendDeleteInvestorCheckAction),
    takeEvery(getType(createInvestorCheckBegin), sendCreateInvestorCheckAction),
    takeEvery(getType(updateInvestorCheckBegin), sendUpdateInvestorCheckAction),
    takeEvery(getType(createInvestorCheckSuccess), showCreateSuccessFlashNotice),
    takeEvery(getType(createInvestorCheckFailure), showFailureFlashNotice),
    takeEvery(getType(updateInvestorCheckSuccess), showUpdateSuccessFlashNotice),
    takeEvery(getType(updateInvestorCheckFailure), showFailureFlashNotice),
    takeEvery(getType(deleteInvestorCheckSuccess), showDeleteSuccessFlashNotice),
    takeEvery(getType(deleteInvestorCheckFailure), showFailureFlashNotice),
  ])
}

function* fetchInvestorChecks() {
  const investorChecks: IdIndexedInvestorChecks = yield callApi(apiGetInvestorChecks)
  yield put(fetchInvestorChecksSuccess(investorChecks))
}

function* fetchAvailableChecks() {
  const availableChecks: ChecksConfig[] = yield callApi(apiGetAvailableChecks)
  yield put(fetchAvailableChecksSuccess(availableChecks))
}

function* sendCreateInvestorCheckAction(action: ActionType<typeof createInvestorCheckBegin>) {
  const { investorCheck } = action.payload

  const savedInvestorCheck: InvestorCheck = yield callApi(apiCreateInvestorCheck, investorCheck)
  yield put(createInvestorCheckSuccess(savedInvestorCheck))
}

function* sendUpdateInvestorCheckAction(action: ActionType<typeof updateInvestorCheckBegin>) {
  const { investorCheck } = action.payload

  const savedInvestorCheck: InvestorCheck = yield callApi(apiUpdateInvestorCheck, investorCheck)
  yield put(updateInvestorCheckSuccess(savedInvestorCheck))
}

function* sendDeleteInvestorCheckAction(action: ActionType<typeof deleteInvestorCheckBegin>) {
  const { investorCheckId } = action.payload

  const investorCheck: InvestorCheck['id'] = yield callApi(apiDeleteInvestorCheck, investorCheckId)
  yield put(deleteInvestorCheckSuccess(investorCheck))
}

function* showCreateSuccessFlashNotice() {
  yield put(
    showFlashNotice({
      message: 'Criterion successfully added!',
      autoHide: true,
      variant: FlashNoticeVariant.success,
    })
  )
}
function* showUpdateSuccessFlashNotice() {
  yield put(
    showFlashNotice({
      message: 'Criterion successfully updated!',
      autoHide: true,
      variant: FlashNoticeVariant.success,
    })
  )
}
function* showDeleteSuccessFlashNotice() {
  yield put(
    showFlashNotice({
      message: 'Criterion successfully deleted!',
      autoHide: true,
      variant: FlashNoticeVariant.success,
    })
  )
}

function* showFailureFlashNotice() {
  yield put(
    showFlashNotice({
      message: 'Error with criterion.',
      autoHide: false,
      variant: FlashNoticeVariant.error,
    })
  )
}
